// extracted by mini-css-extract-plugin
module.exports = {"synthesis":"Alerts_synthesis__ckucw"};